import { Payment } from '@fhs-legacy/frontend/src/pages/cart/payment/order-payment/payment';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function CartPaymentPage() {
  return <Payment />;
}
